module.exports = "https://s91588.cdn.ngenix.net/microcredits-frontend/_next/static/images/resultOzonPrize-f3614f9262cf69175aa39aa3edbbc976.png";